import { Link } from 'react-router-dom';
import { articles, type ArticleItem } from '@/mocks/articles';

function ArticleCard({ article }: { article: ArticleItem }) {
  return (
    <Link
      to={`/article/${article.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl border border-background-200 p-4 transition-all duration-200 hover:border-primary-200 cursor-pointer"
    >
      {/* Thumbnail */}
      <div className="relative w-full sm:w-48 flex-shrink-0 aspect-video sm:aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={`${article.title} - 蘑菇视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
          {article.category}
        </span>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <h3 className="text-base md:text-lg font-medium text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views}阅读
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function ArticleList() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            影视资讯
          </h2>
          <Link
            to="/article/a1"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-4">
          {articles.slice(0, 4).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}